import { createSlice } from "@reduxjs/toolkit";

export const shelfViewFeedbackSlice = createSlice({
  name: "shelfViewFeedback",
  initialState: {
    loading: false,
    snackbarOpen: false,
    snackbarMessage: "",
    snackbarMessageSeverity: "info",
    zoomDynamicHeight:150,
    selectedZoom:null
  },
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setSnackbarOpen(state, action) {
      state.snackbarOpen = action.payload;
    },
    setSnackbarMessage(state, action) {
      state.snackbarMessage = action.payload;
    },
    setSnackbarMessageSeverity(state, action) {
      state.snackbarMessageSeverity = action.payload;
    },
     setZoomDynamicHeight(state,action){
      state.zoomDynamicHeight=action.payload
    },
    setZoom(state,action){
      state.selectedZoom=action.payload
    },
    increaseHeight(state,action){
      if(state.zoomDynamicHeight<350)
      {
        state.zoomDynamicHeight=state.zoomDynamicHeight+10;
      }
     else{
      state.zoomDynamicHeight=state.zoomDynamicHeight;
     }
    },
    decreaseHeight(state,action){
      if(state.zoomDynamicHeight>100)
      {
        state.zoomDynamicHeight=state.zoomDynamicHeight-10;
      }
     else{
      state.zoomDynamicHeight=state.zoomDynamicHeight;
     }
    }
  }
})